// extracted by mini-css-extract-plugin
export default {"root":"OKGj8__root","subtitles":"HXyUa__subtitles"};